import { Component} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
declare function getMapApi(apiKey:string): void;
@Component({
    selector: 'app-root',
    standalone: true,
    templateUrl: './app.component.html',
    imports: [RouterOutlet]
})
export class AppComponent {

    ngOnInit(): void {
        getMapApi(environment.googleMapKey);
    }

}
